import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap";

// import images
import profile from "@assets/images/profile-img.png";
import logoImg from "@assets/images/logo.svg";
import lightlogo from "@assets/images/logo-light.svg";

const ResetPassword = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4 text-start">
                        <h5 className="text-primary"> Reset Password</h5>
                        <p>Reset Password with VV-media.</p>
                      </div>
                    </Col>
                    <Col xs={5} className="align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <div className="auth-logo">
                      <Link to="/" className="auth-logo-light">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={lightlogo}
                              alt=""
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                      <Link to="/" className="auth-logo-dark">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logoImg}
                              alt=""
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="p-2">
                    {/* <div
                      className="alert alert-success text-center mb-4"
                      role="alert"
                    >  </div> */}

                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        navigate("/login");
                        return false;
                      }}
                    >
                      <div className="mb-3 text-start">
                        <Label className="form-label"> New Password:</Label>
                        <div className="input-group auth-pass-inputgroup">
                          <Input
                            // {...formik.getFieldProps("password")}
                            name="new-password"
                            id="new-password"
                            placeholder="Enter password"
                            type={show ? "text" : "password"}
                            autoComplete="off"
                          />
                          <button
                            onClick={() => setShow(!show)}
                            className="btn btn-light"
                            type="button"
                            id="new-password-addon"
                          >
                            <i className="mdi mdi-eye-outline"></i>
                          </button>
                        </div>
                        {/* {formik.touched.password && formik.errors.password ? (
                      <p className="error">{formik.errors.password}</p>
                      ) : null} */}
                      </div>
                      <div className="mb-3 text-start">
                        <Label className="form-label"> Confirm Password:</Label>
                        <div className="input-group auth-pass-inputgroup">
                          <Input
                            // {...formik.getFieldProps("password")}
                            name="password"
                            id="confirm-password"
                            placeholder="Enter password"
                            type={show ? "text" : "password"}
                            autoComplete="off"
                          />
                          <button
                            onClick={() => setShow(!show)}
                            className="btn btn-light"
                            type="button"
                            id="confirm-password-addon"
                          >
                            <i className="mdi mdi-eye-outline"></i>
                          </button>
                        </div>
                        {/* {formik.touched.password && formik.errors.password ? (
                <p className="error">{formik.errors.password}</p>
                ) : null} */}
                      </div>
                      <div className="text-end mt-3">
                        <button className="btn btn-primary w-md" type="submit">
                          Reset
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;
